export default "__VITE_ASSET__1a615312__"